import * as React from 'react';

import { RadioCard, RadioGroup } from '@coursera/cds-core';

import _t from 'i18n!nls/admin-dashboard';

type Props = {
  migrateLearners: boolean;
  onChangeMigrateLearners: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const PrivateSessionEditDrawerStep2: React.FC<Props> = ({ onChangeMigrateLearners, migrateLearners }) => {
  return (
    <RadioGroup
      onChange={onChangeMigrateLearners}
      defaultValue={String(migrateLearners)}
      label={_t('Migrate enrolled learners to the selected schedule?')}
      supportText={_t(
        'Learners currently enrolled in this course who did not complete the course will be automatically migrated to the new schedule'
      )}
    >
      <RadioCard label={_t('Yes')} value="true" data-testid="enable-migrate-learners-radio-button" />
      <RadioCard label={_t('No')} value="false" data-testid="disable-migrate-learners-radio-button" />
    </RadioGroup>
  );
};

export default PrivateSessionEditDrawerStep2;
